import h from 'snabbdom/h';

export default function marker(store, percentPlayed, duration, visible) {

  const markerStyle = {
    width: '0',
    height: '100%',
    position: 'absolute',
    left: percentPlayed + '%',
    top: '0',
    pointerEvents: 'auto',
    cursor: 'pointer',
  };

  let toolTipStyle = {
    boxSizing: 'border-box',
    position: 'absolute',
    zIndex: '1070',
    display: 'block',
    visibility: 'visible',
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '1.4',
    top: '-32px',
    left: '-25px',
    width: '50px',
    height: '22px',
    marginTop: '-3px',
    padding: '5px 0',
    opacity: '1',
  };
  if (!visible) {
    toolTipStyle.opacity = '0';
    toolTipStyle.transition = 'opacity 0.15s linear';
  }

  const innerStyle = {
    maxWidth: '200px',
    padding: '3px 8px',
    color: '#ffffff',
    textAlign: 'center',
    textDecoration: 'none',
    backgroundColor: '#000000',
    borderRadius: '4px',
    boxShadow: '#000 0 0 5px',
    margin: '0 auto',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
  };

  const arrowStyle = {
    boxSizing: 'border-box',
    position: 'absolute',
    width: '0',
    height: '0',
    bottom: '-10px',
    left: '50%',
    marginLeft: '-5px',
    borderWidth: '5px 5px 0',
    borderTopColor: '#000000',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    borderStyle: 'solid',
  };

  function stopEvent(ev) {
    ev.stopPropagation();
  }

  return h('div.marker', { style: markerStyle, on: { mousedown: stopEvent, touchstart: stopEvent } }, [
    h('div.tooltip', { style: toolTipStyle }, [
      h('div.tooltip-arrow', { style: arrowStyle }),
      h('div.tooltip-inner', { style: innerStyle }, (duration * percentPlayed / 100000).toFixed(1)),
    ]),
  ]);
}



// WEBPACK FOOTER //
// ./src/components/marker.js